import Slider from "react-slick";

const MainSlider = ({ banners }) => {
  const isMobile = window?.screen?.width < 768;

  const settings = {
    speed: 2000,
    autoplay: true,
    arrows: false,
    dots: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="mainBanner">
      {isMobile ? (
        // Mobile
        <Slider {...settings}>
          {Array.isArray(banners) &&
            banners
              ?.filter((f) => f?.order >= 100)
              ?.map((banner, idx) => {
                return (
                  <div key={idx}>
                    <img src={banner?.link} />
                  </div>
                );
              })}
        </Slider>
      ) : (
        // Desktop
        <Slider {...settings}>
          {" "}
          {Array.isArray(banners) &&
            banners
              ?.filter((f) => f?.order < 100)
              ?.map((banner, idx) => {
                return (
                  <div key={idx}>
                    <img src={banner?.link} />
                  </div>
                );
              })}
        </Slider>
      )}
    </div>
  );
};

export default MainSlider;
